import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReportEmptyData from 'modules/Report/components/EmptyData';
import ReportInfoBlock from 'modules/Report/components/InfoBlock';
import ReportInfoBlockGrid from 'modules/Report/components/InfoBlock/grid';

import { getRoute } from '@common/constants/CampusRoutes';

import {
	PortfolioGoBackButton,
	PortfolioGoBackSection,
	PortfolioPageWrap,
	PortfolioTitle,
} from './style';

function PortfolioPage() {
	const navigate = useNavigate();
	const handleGoBack = () => {
		navigate(getRoute(['REPORT', 'ACHIEVEMENT']));
	};

	const { t } = useTranslation();

	return (
		<PortfolioPageWrap>
			<PortfolioGoBackSection>
				<PortfolioGoBackButton onClick={handleGoBack}>
					<ArrowBackIcon color="primary" />
				</PortfolioGoBackButton>
				<PortfolioTitle variant="h4">
					{t('report.achievements.myEducationPlannerPortfolio')}
				</PortfolioTitle>
			</PortfolioGoBackSection>
			<ReportInfoBlockGrid>
				<ReportInfoBlock title={t('report.achievements.knowledge')}>
					<ReportEmptyData type="document" />
				</ReportInfoBlock>
				<ReportInfoBlock
					title={t('report.achievements.projects')}
					// onAddFileClick={() => console.info('add file')}
				>
					<ReportEmptyData type="leaf" />
				</ReportInfoBlock>
				<ReportInfoBlock
					title={t('report.achievements.main')}
					// onAddFileClick={(data) => console.info(data)}
				>
					<ReportEmptyData type="leaf" />
				</ReportInfoBlock>
			</ReportInfoBlockGrid>
		</PortfolioPageWrap>
	);
}

export default PortfolioPage;
